<template>
    <div class="user-list">
        <div class="user-list-container">
            <v-row>
                <v-col class="user-list-list-inactive-container">
                    <span class="user-list-list-inactive-card">
                        <v-checkbox v-model="listInactiveUsers" hide-details class="mt-0">
                            <template v-slot:label>
                               <span class="color-blue-onfly-darker">
                                   Listar desativados
                               </span>
                            </template>
                        </v-checkbox>
                    </span>
                </v-col>
                <v-col class="d-flex justify-end">
                    <v-btn
                        color="primary"
                        class="ms-auto mb-6"
                        @click="createUser"
                    >
                        <v-icon class="mr-2">mdi-account-plus</v-icon>Novo Usuário
                    </v-btn>
                </v-col>
            </v-row>
            <list-user @edit-user="editUser" :list-inactive-users="listInactiveUsers"/>
            <user-form-drawer
                :drawer="drawer"
                :user="userToEdit"
            >
            </user-form-drawer>
        </div>
    </div>
</template>

<script>
import ListUser from "../../components/User/ListUser";
import UserFormDrawer from "../../components/User/UserFormDrawer";

export default {
    name: "UserList",

    components: {
        ListUser,
        UserFormDrawer,
    },

    data: () => ({
        drawer: false,
        userToEdit: {},
        listInactiveUsers: false
    }),

    methods: {
        editUser(user) {
            this.userToEdit = user;
            this.drawer = !this.drawer;
        },

        createUser() {
            this.userToEdit = {};
            this.drawer = !this.drawer;
        }
    },

}
</script>

<style lang="scss" scoped>
.user-list {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        padding: 20px;
        width: 100%;
    }
    &-list-inactive-card {
        display: inline-block;
        padding: 4px 8px 6px 8px;
        background: #fff;
        border-radius: 8px;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
        font-weight: 500;
    }
}
</style>
